import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Container} from "@pg-design/grid-module";
import {flexJustifyCenter, m, mt, pb, pl, pt} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {ColumnList} from "../../../atoms/ColumnList";
import {ColumnListItem} from "../../../atoms/ColumnListItem";
import {DesktopBlend} from "../../../atoms/DesktopBlend";
import {VendorEmptyList} from "../../atoms/VendorEmptyList";
import {IVendorListStore} from "../../reducers/vendor_list_reducer";
import {SearchVendor} from "../SearchVendor";
import {VendorBox} from "../VendorBox";
import {VendorListHeader} from "./VendorListHeader";

interface IProps {
    list: IVendorListStore;
}

export const VendorListListSection = React.memo((props: IProps) => {
    const {count, region, requestState, vendors, allOffersCount, soldVendors, soldVendorsCount} = props.list;
    const areVendorsAvailable = count > 0;
    const areSoldVendorsAvailable = soldVendorsCount > 0;
    const shouldShowDefaultEmptyList = requestState === RequestState.Success && !areVendorsAvailable && !areSoldVendorsAvailable;

    return (
        <>
            {requestState === RequestState.Waiting && (
                <DesktopBlendStyled top="13rem" isActive>
                    <div css={[flexJustifyCenter, loaderHolder]}>
                        <Loader size="lg" />
                    </div>
                </DesktopBlendStyled>
            )}

            <Container css={headerHolder}>
                <div css={vendorSearchHolder}>
                    <SearchVendor latestQuery={props.list.latestQuery} />
                </div>

                <VendorListHeader vendorsCount={count} region={region} allOffersCount={allOffersCount} css={vendorHeaderHolder} page={props.list.page} />
            </Container>

            {areVendorsAvailable && (
                <ColumnList>
                    {vendors.map((vendor) => {
                        return (
                            <ColumnListItem key={vendor.id}>
                                <VendorBox vendor={vendor} />
                            </ColumnListItem>
                        );
                    })}
                </ColumnList>
            )}
            {shouldShowDefaultEmptyList && (
                <Container>
                    <VendorEmptyList css={vendorEmptyListHolder} />
                </Container>
            )}
            {areSoldVendorsAvailable && (
                <>
                    <Container>
                        <VendorEmptyList
                            customHeading="Nie znaleźliśmy (więcej) deweloperów, którzy oferują inwestycje w tej lokalizacji."
                            customSubHeading="Sprawdź deweloperów, którzy zakończyli już sprzedaż w tym regionie."
                            css={vendorEmptyListHolder}
                        />
                    </Container>

                    <ColumnList>
                        {soldVendors.map((vendor) => {
                            return (
                                <ColumnListItem key={vendor.id}>
                                    <VendorBox vendor={vendor} />
                                </ColumnListItem>
                            );
                        })}
                    </ColumnList>
                </>
            )}
        </>
    );
}, isEqual);

const headerHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    ${pt(2)};
    ${pb(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        align-items: stretch;
    }
`;

const vendorHeaderHolder = (theme: Theme) => css`
    flex-grow: 1;
    flex-basis: 100%;
    order: 2;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-basis: 60%;
        order: 1;
    }
`;

const vendorSearchHolder = (theme: Theme) => css`
    flex-grow: 1;
    order: 1;
    ${pb(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-basis: 40%;
        order: 2;
        ${pl(2)};
        ${pb(0)};
    }
`;

const vendorEmptyListHolder = css`
    ${m(8, 0)}
`;

const DesktopBlendStyled = styled(DesktopBlend)`
    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        background: rgba(255, 255, 255, 0.7);
    }
`;

const loaderHolder = css`
    ${mt(10)};
`;
import React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Container} from "@pg-design/grid-module";
import {flexJustifyCenter, m, mt, pb, pl, pt} from "@pg-design/helpers-css";
import {Loader} from "@pg-design/loader-module";
import {isEqual} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {ColumnList} from "../../../atoms/ColumnList";
import {ColumnListItem} from "../../../atoms/ColumnListItem";
import {DesktopBlend} from "../../../atoms/DesktopBlend";
import {VendorEmptyList} from "../../atoms/VendorEmptyList";
import {IVendorListStore} from "../../reducers/vendor_list_reducer";
import {SearchVendor} from "../SearchVendor";
import {VendorBox} from "../VendorBox";
import {VendorListHeader} from "./VendorListHeader";

interface IProps {
    list: IVendorListStore;
}

export const VendorListListSection = React.memo((props: IProps) => {
    const {count, region, requestState, vendors, allOffersCount, soldVendors, soldVendorsCount} = props.list;
    const areVendorsAvailable = count > 0;
    const areSoldVendorsAvailable = soldVendorsCount > 0;
    const shouldShowDefaultEmptyList = requestState === RequestState.Success && !areVendorsAvailable && !areSoldVendorsAvailable;

    return (
        <>
            {requestState === RequestState.Waiting && (
                <DesktopBlendStyled top="13rem" isActive>
                    <div css={[flexJustifyCenter, loaderHolder]}>
                        <Loader size="lg" />
                    </div>
                </DesktopBlendStyled>
            )}

            <Container css={headerHolder}>
                <div css={vendorSearchHolder}>
                    <SearchVendor latestQuery={props.list.latestQuery} />
                </div>

                <VendorListHeader vendorsCount={count} region={region} allOffersCount={allOffersCount} css={vendorHeaderHolder} page={props.list.page} />
            </Container>

            {areVendorsAvailable && (
                <ColumnList>
                    {vendors.map((vendor) => {
                        return (
                            <ColumnListItem key={vendor.id}>
                                <VendorBox vendor={vendor} />
                            </ColumnListItem>
                        );
                    })}
                </ColumnList>
            )}
            {shouldShowDefaultEmptyList && (
                <Container>
                    <VendorEmptyList css={vendorEmptyListHolder} />
                </Container>
            )}
            {areSoldVendorsAvailable && (
                <>
                    <Container>
                        <VendorEmptyList
                            customHeading="Nie znaleźliśmy (więcej) deweloperów, którzy oferują inwestycje w tej lokalizacji."
                            customSubHeading="Sprawdź deweloperów, którzy zakończyli już sprzedaż w tym regionie."
                            css={vendorEmptyListHolder}
                        />
                    </Container>

                    <ColumnList>
                        {soldVendors.map((vendor) => {
                            return (
                                <ColumnListItem key={vendor.id}>
                                    <VendorBox vendor={vendor} />
                                </ColumnListItem>
                            );
                        })}
                    </ColumnList>
                </>
            )}
        </>
    );
}, isEqual);

const headerHolder = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    ${pt(2)};
    ${pb(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
        align-items: stretch;
    }
`;

const vendorHeaderHolder = (theme: Theme) => css`
    flex-grow: 1;
    flex-basis: 100%;
    order: 2;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-basis: 60%;
        order: 1;
    }
`;

const vendorSearchHolder = (theme: Theme) => css`
    flex-grow: 1;
    order: 1;
    ${pb(3)};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-basis: 40%;
        order: 2;
        ${pl(2)};
        ${pb(0)};
    }
`;

const vendorEmptyListHolder = css`
    ${m(8, 0)}
`;

const DesktopBlendStyled = styled(DesktopBlend)`
    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        background: rgba(255, 255, 255, 0.7);
    }
`;

const loaderHolder = css`
    ${mt(10)};
`;
